import { isSingleItemArray } from './is-single-item-array.ts'

// Given array of unknown length, return a SingleItemArray if it has exactly one item, otherwise an empty array even if there are 100 or 0 items, or undefined.
export function oneOrEmpty<ItemType>(arr: ItemType[] | undefined) {
  return isSingleItemArray(arr) ? arr : ([] as ItemType[])
}
